<button
    type="button"
    class="btn m-0 d-flex align-items-center"
    [ngClass]="isTrainPage || isSegmentationDetailPage ? 'btn btn-secondary' : 'btn ca-btn-icon'"
    (click)="onClickBtn()"
    [ngbTooltip]="title"
    [disabled]="disabled"
    data-uit="file-download-btn"
    #buttonRef
>
    <ca-spinner-circular [size]="36" [color]="'#28b4f5'" *ngIf="isBusy"></ca-spinner-circular>
    <ca-icon name="download" size="s" class="download-icon me-0" *ngIf="!isBusy"></ca-icon>
    <ca-icon name="{{ isBusyIcon }}" size="s" class="busy-icon me-0" *ngIf="isBusy"></ca-icon>

    <span [ngClass]="isTrainPage || isSegmentationDetailPage ? 'ms-2' : 'ms-0'">{{ description }}</span>
</button>
